// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 657 ? "93b25bb5" : chunkId) + "." + {"657":"13d0efba60b187ef","870":"d30fc6759d7f2f2f"}[chunkId] + ".js";
};